import React, { useEffect, useState } from "react";
import AdminHeader from "../../../layouts/admin/AdminHeader";
import { AdminReviewTable } from "./AdminReviewTable";
import AddReviewModal from "./AddReviewModal";
import ImportReviewModel from "./ImportReviewModal";
import {
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import sampleCsv from "../../../assets/files/sample.csv"; // Correctly import the CSV
import { getAllActiveProviderApi } from "../../../api/adminApi/adminApi";
import useEncryption from "../../../services/useEncryption";
import useHeaders from "../../../helpers/useHeaders";

export const AdminReview = () => {
  const [open, setOpen] = useState(false);
  const [importOpen, setImportOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [update, setUpdate] = useState(false);
  const [providerId, setProviderId] = useState("");
  const { decryptData } = useEncryption();
  const [providers, setProviders] = useState([]);
  const headers = useHeaders();

  const handleAddReviewOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setImportOpen(false);
    setUpdate((prev) => !prev);
  };

  const handleImportCsv = () => {
    setImportOpen(true);
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handleUpdate = () => {
    setUpdate((prev) => !prev);
  };

  const handleDownloadSampleCsv = () => {
    const sampleCsvUrl = sampleCsv;
    const link = document.createElement("a");
    link.href = sampleCsvUrl;
    link.download = "sample.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fetchData = async () => {
    try {
      const response = await getAllActiveProviderApi(headers);
      const decryptedData = decryptData(response?.data?.data);
      setProviders(decryptedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <AdminHeader pageTitle="Reviews" />
      <div className="cardOuter">
        <div className="cardheads">
          <div className="cardTitle">Reviews</div>
          <button className="btn blackoutlineBtn" onClick={handleUpdate}>
            Refresh
          </button>
        </div>
        <div className="cardcontents">
          <div className="tabpanelControl mt-3">
            <div className="topsearchs">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex">
                  <div className="searchBar">
                    <input
                      type="text"
                      autoComplete="off"
                      placeholder="Search"
                      value={search}
                      onChange={handleSearchChange}
                    />
                  </div>
                  <div className="formdesign" style={styles.container}>
                    <FormControl sx={{ minWidth: 160 }} size="small">
                      <InputLabel id="location-label">
                        Select Location
                      </InputLabel>
                      <Select
                        labelId="location-label"
                        id="location"
                        name="location"
                        label="Select Location"
                        value={providerId}
                        onChange={(e) => {
                          setProviderId(e.target.value);
                        }}
                      >
                        <MenuItem value="all">All</MenuItem>
                        {providers.map((provider) => (
                          <MenuItem key={provider.id} value={provider.id}>
                            {provider.organizationName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div>
                  <button
                    className="btn blackoutlineBtn outline me-2"
                    onClick={() => handleAddReviewOpen()}
                  >
                    Add Review
                  </button>
                  <button
                    className="btn blackoutlineBtn"
                    onClick={() => handleImportCsv()}
                  >
                    Import CSV
                  </button>
                  <Tooltip title="Download sample csv file." arrow>
                    <IconButton
                      color="primary"
                      aria-label="download sample csv"
                      onClick={handleDownloadSampleCsv}
                    >
                      <DownloadIcon style={{ color: "black" }} />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
              <AdminReviewTable
                search={search}
                update={update}
                setUpdate={setUpdate}
                providerId={providerId}
              />
            </div>
          </div>
        </div>
      </div>
      <AddReviewModal open={open} handleClose={handleClose} />
      <ImportReviewModel importOpen={importOpen} handleClose={handleClose} />
    </div>
  );
};

const styles = {
  container: {
    marginLeft: "20px",
  },
};
